module.exports = __webpack_public_path__ + "img/home-circle-3.0fbc6721.png";